const ACTIONS = {
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    GET_PLAYER_GAMELOG_SUCCESS: 'GET_PLAYER_GAMELOG_SUCCESS',
    GET_PLAYER_GAMELOG_ERROR: 'GET_PLAYER_GAMELOG_ERROR',
    GET_PLAYER_GAMELOG_PITCHER_SUCCESS: 'GET_PLAYER_GAMELOG_PITCHER_SUCCESS',
    GET_PLAYER_GAMELOG_PITCHER_ERROR: 'GET_PLAYER_GAMELOG_PITCHER_ERROR',
    GET_PLAYER_GAMELOG_BATTER_SUCCESS: 'GET_PLAYER_GAMELOG_BATTER_SUCCESS',
    GET_PLAYER_GAMELOG_BATTER_ERROR: 'GET_PLAYER_GAMELOG_BATTER_ERROR'
};

const titlePerformance = {
    dot: false,
    text: '投手成績',
};
const headerPerformance = ['', '試合日付', '相手', '勝敗SH', '完投', '当初', '投球回', '投球数', '打者', '被安打', '被本塁打', '与四球', '与死球',
    '奪三振', '暴投', 'ボーク', '失点', '自責点', '防御率', 'BB/9', 'K/9', 'K/BB', 'WHIP',];

const titleResult = {
    dot: false,
    text: '打撃成績',
}
const headerResult = ['', '試合日付', '相手', '打席', '打数', '得点', '安打', '二塁打', '三塁打', '本塁打', '塁打', '打点',
    '三振', '四球', '敬遠', '死球', '犠打', '犠飛', '盗塁', '盗塁刺', '併殺打', '失策', '打率', '長打率', '出塁率', 'OPS',];

const dataList1 = [
];


const dataList2 = [
];
export default (state = {
    titlePerformance, headerPerformance, titleResult,
    headerResult, dataList1, dataList2
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_PLAYER_GAMELOG_SUCCESS:
        case ACTIONS.GET_PLAYER_GAMELOG_PITCHER_SUCCESS:
        case ACTIONS.GET_PLAYER_GAMELOG_BATTER_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_DATA_ERROR:
        case ACTIONS.GET_PLAYER_GAMELOG_ERROR:
        case ACTIONS.GET_PLAYER_GAMELOG_PITCHER_ERROR:
        case ACTIONS.GET_PLAYER_GAMELOG_BATTER_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};